import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Components
import Layout from '../layout/Layout';
import { ProtectedRoute } from './ProtectedRoute';
import { protectedRoutes } from './routeConfig';
// Note: OrganizationProvider is no longer needed with Zustand store

// Auth pages
import Login from '../../pages/Login';
import Register from '../../pages/Register';
import VerifyEmail from '../../pages/VerifyEmail';
import ResendVerification from '../../pages/ResendVerification';
import AuthCallback from '../../pages/AuthCallback';
import NotFound from '../../pages/NotFound';

// Special pages with custom layout
import MultiChat from '../../pages/MultiChat';

interface AppRoutesProps {
  authenticated: boolean;
  onLogin: (user: any) => void;  // CHANGED: Removed token parameter (cookies handle auth)
  onLogout: () => void;
}

export const AppRoutes: React.FC<AppRoutesProps> = ({ 
  authenticated, 
  onLogin, 
  onLogout 
}) => {
  return (
    <Routes>
      {/* Public auth routes */}
      <Route path="/login" element={
        // authenticated ? <Navigate to="/dashboard" /> : <Login onLogin={onLogin} />
        authenticated ? <Navigate to="/chat" /> : <Login onLogin={onLogin} />
      } />
      <Route path="/register" element={
        // authenticated ? <Navigate to="/dashboard" /> : <Register />
        authenticated ? <Navigate to="/chat" /> : <Register />
      } />
      <Route path="/verify-email" element={
        // authenticated ? <Navigate to="/dashboard" /> : <VerifyEmail />
        authenticated ? <Navigate to="/chat" /> : <VerifyEmail />
      } />
      <Route path="/resend-verification" element={
        // authenticated ? <Navigate to="/dashboard" /> : <ResendVerification />
        authenticated ? <Navigate to="/chat" /> : <ResendVerification />
      } />
      <Route path="/auth/callback" element={
        // authenticated ? <Navigate to="/dashboard" /> : <AuthCallback onLogin={onLogin} />
        authenticated ? <Navigate to="/chat" /> : <AuthCallback onLogin={onLogin} />
      } />

      {/* Chat route with layout - supports optional conversationId parameter */}
      <Route element={<Layout onLogout={onLogout} />}>
        <Route path="/chat/:conversationId?" element={
          <ProtectedRoute authenticated={authenticated}>
            <MultiChat />
          </ProtectedRoute>
        } />
      </Route>

      {/* Protected routes with layout */}
      <Route element={<Layout onLogout={onLogout} />}>
        {protectedRoutes.map(({ path, component: Component, permission }) => (
          <Route
            key={path}
            path={path}
            element={
              <ProtectedRoute authenticated={authenticated} permission={permission}>
                <Component />
              </ProtectedRoute>
            }
          />
        ))}
      </Route>

      {/* Default and 404 routes */}
      <Route path="/" element={
        // authenticated ? <Navigate to="/dashboard" /> : <Navigate to="/login" />
        authenticated ? <Navigate to="/chat" /> : <Navigate to="/login" />
      } />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};